<template>
  <el-dialog
    title=""
    :visible.sync="visible"
    width="60%"
    append-to-body
    top="15vh"
  >
    <div class="main__container">
      <!-- <img class="close" src="./img/delete.png" alt="" @click="handlerClose" /> -->
      <div class="wrapper1">
        <!-- <img src="./img/dialog-bg.png" class="bg-img" alt="" /> -->
        <div class="content">
          <div>小区名称-{{ plotKey }}</div>
          <div style="width: 100%" class="mt-10">
            <el-input v-model="keyBuildings" placeholder="搜索楼栋">
              <div slot="suffix">
                <div
                  class="flex justify-center items-center cursor-pointer"
                  style="height: 42px; width: 50px"
                >
                  <img
                    @click="onSearch"
                    style="width: 20px; height: 20px"
                    src="./img/search.png"
                    alt=""
                  />
                </div>
              </div>
            </el-input>
            <div class="list__container">
              <div
                v-for="(item, index) in filterbuildingsList"
                :key="index"
                :class="{
                  flex: true,
                  'items-center': true,
                  'cursor-pointer': true,
                  item: true,
                  'mt-5': true,
                  'pl-10': true,
                  active: item.building == checkBuilds.building,
                }"
                @click="onCheckBuilds(item)"
              >
                <!-- class="flex items-center item mt-5 pl-10 cursor-pointer" -->

                <img
                  src="./img/house.png"
                  alt=""
                  style="height: 20px; width: 20px"
                />
                <div class="ml-4 pt-5 pb-5" style="width: 100%">
                  <div class="flex justify-between pr-10">
                    <div>{{ item.building }}</div>
                    <div>{{ item.users.length || 0 }}人</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div slot="footer">
              <div
                class="flex justify-center items-center cursor-pointer"
                style="width: 100%; margin-top: 50px"
                @click="handleSubmit"
              >
                <dv-decoration-11
                  style="width: 200px; height: 60px"
                  :color="['#456AD6', '#456AD6']"
                  >确 定</dv-decoration-11
                >
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <!-- <div class="wrapper2 ml-6" v-if="userList.length">
        <img src="./img/dialog-bg.png" class="bg-img" alt="" />
        <div class="content">
          <div>{{ checkBuilds.building }}</div>
          <div style="width: 100%" class="mt-10">
            <el-input v-model="keyUser" placeholder="搜索用户">
              <div slot="suffix">
                <div
                  :class="{
                    flex: true,
                    'justify-center': true,
                    'items-center': true,
                    'cursor-pointer': true,
                  }"
                  style="height: 42px; width: 50px"
                >
                  <img
                    @click="onSearchUser"
                    style="width: 20px; height: 20px"
                    src="./img/search.png"
                    alt=""
                  />
                </div>
              </div>
            </el-input>
            <div class="list__container">
              <el-table
                :data="filterUserList"
                style="width: 100%"
                class-name="table-name"
                :header-cell-style="{
                  color: '#abd1e7',
                }"
                @row-click="onCheckoutItemOfUser"
              >
                <el-table-column prop="name" label="姓名" width="80">
                </el-table-column>
                <el-table-column prop="gender" label="性别" width="60">
                </el-table-column>
                <el-table-column prop="age" label="年龄" width="60">
                </el-table-column>
                <el-table-column prop="house_number" label="楼号" width="190">
                  <template slot-scope="{ row }">
                    <div>
                      {{
                        `${row.community}-${row.building}-${row.house_number}`
                      }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="house_number" label="档案标签">
                  <template slot-scope="{ row }">
                    <div v-html="formatRiskLevel(row.riskLevel)"></div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="wrapper3 ml-6" v-if="archivesDetail.archive.sn">
        <ArchivesCard :sn="checkUsers.sn" :detail="archivesDetail" />
      </div> -->
      <DialogUserTable
        :tableData="filterUserList"
        :show.sync="visibleUser"
        @onSelect="onCheckoutItemOfUser"
        @back="handleBack"
        showBack
      ></DialogUserTable>
      <DialogArchivesCard
        :id="checkUsers.sn"
        :show.sync="visibleArchives"
        @back="visibleUser = true"
      ></DialogArchivesCard>
    </div>
    <!-- <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="visible = false">确 定</el-button>
    </span> -->
  </el-dialog>
</template>
<script>
import { mapGetters } from "vuex";
import ArchivesCard from "./ArchivesCard.vue";
import DialogUserTable from "./DialogUserTable.vue";
import DialogArchivesCard from "./DialogArchivesCard.vue";
export default {
  components: {
    ArchivesCard,
    DialogUserTable,
    DialogArchivesCard,
  },
  data() {
    return {
      keyBuildings: "",
      keyUser: "",
      checkBuilds: {},
      filterbuildingsList: [],
      buildingsList: [],
      filterUserList: [],
      userList: [],
      checkUsers: {},
      config: {},
      archivesDetail: {
        archive: {
          sn: null,
        },
      },
      visibleUser: false,
      visibleArchives: false,
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show(n) {
      //   n && this.init();
    },
    plotKey(n) {
      if (n) {
        this.init();
        setTimeout(() => {
          let list = this.globalData.buildingUsers;
          list.forEach((v) => {
            if (v.building.indexOf("栋") > -1) {
              v.sort = Number(v.building.split("栋")[0]);
            } else {
              v.sort = 0;
            }
          });
          list.sort((a, b) => {
            return a.sort - b.sort;
          });
          this.filterbuildingsList = list;
          console.log("list=======> 楼栋", list);
          this.buildingsList = list;
        }, 500);
      }
    },
  },
  computed: {
    ...mapGetters(["globalData", "key", "token", "plotKey"]),
    visible: {
      get() {
        return this.show;
      },
      set(n) {
        this.$emit("update:show", n);
      },
    },
    // buildingsList() {
    //   return this.globalData.communityUsers
    //     .filter((v) => {
    //       return v.community == this.key;
    //     })
    //     .map((v) => {
    //       return {
    //         ...v,
    //         name: v.building,
    //       };
    //     });
    // },
  },
  methods: {
    handleBack() {
      this.visible = true;
    },
    handlerClose() {
      this.visible = false;
    },

    formatRiskLevel(level = 0) {
      let map = new Map([
        [0, `<span style="color:#34C724;">基本健康人群</span>`],
        [1, `<span style="color:#34C724;">基本健康人群</span>`],
        [2, `<span style="color:#FF8800;">专项关爱人群</span>`],
        [3, `<span style="color:#F54A45;">重点关爱人群</span>`],
      ]);
      return map.get(level);
    },
    onSearch() {
      if (!this.keyBuildings) {
        this.filterbuildingsList = this.buildingsList;
        return;
      }
      console.log("搜索的key", this.keyBuildings);
      console.log("this.buildingsList", this.buildingsList);
      this.filterbuildingsList = this.buildingsList.filter((v) =>
        v.building.includes(this.keyBuildings)
      );
    },
    onSearchUser() {
      if (!this.keyUser) {
        this.filterUserList = this.userList;
        return;
      }
      this.filterUserList = this.userList.filter((v) => {
        v.name.includes(this.keyUser);
      });
    },
    onCheckItem(item) {
      this.key = item.building;
      this.filterUserList = item.users;
      this.userList = item.users;
    },
    onCheckBuilds(item) {
      console.log(item);

      this.filterUserList = item.users;
      this.userList = item.users;
      this.checkBuilds = item;
      this.visibleUser = true;
      this.visible = false;
    },
    onCheckoutItemOfUser(row) {
      this.checkUsers = row;
      // this.getArchivesDetail();
      this.visibleUser = false;
      this.visibleArchives = true;
      return;
    },
    init() {
      this.keyBuildings = "";
      this.keyUser = "";
      this.checkBuilds = {};
      this.filterbuildingsList = [];
      this.buildingsList = [];
      this.filterUserList = [];
      this.userList = [];
      this.checkUsers = {};
      this.config = {};
      //   this.filterList = this.buildingsList;
    },
    handleSubmit() {
      this.$store
        .dispatch("app/getGlobalData", { key: this.key })
        .then((resp) => {
          this.visible = false;
        });
    },
  },
  mounted() {
    // this.filterList = this.buildingsList;
  },
};
</script>
<style scoped lang="less">
.main__container {
  display: flex;
  height: 100%;
  width: 100%;
  position: relative;
  flex-wrap: nowrap;

  .close {
    width: 30px;
    height: 30px;
    position: absolute;
    right: 40px;
    top: 30px;
    z-index: 11111;
    cursor: pointer;
  }
}
.wrapper1 {
  width: 100% !important;
}
// .wrapper1,
// .wrapper2,
// .wrapper3 {
//   position: relative;
// }
// .wrapper1 {
//   width: 25%;
//   height: 620px;
// }
// .wrapper2 {
//   width: 40%;
//   height: 620px;
// }
// .wrapper3 {
//   width: 35%;
// }
// .wrapper {
//   position: relative;
//   width: 100%;
//   height: 100%;
// }
.bg-img {
  position: absolute;
  height: 100%;
  width: 100%;
}
.content {
  position: relative;
  z-index: 2;
  color: #333;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 50px;
  font-weight: bold;
  font-size: 20px;
  width: 100%;
}
.list__container {
  margin-top: 30px;
  height: 370px;
  overflow: scroll;
  .item {
    width: 100%;
    height: 39px;
    // background: linear-gradient(90deg, #161f4e 0%, rgba(4, 24, 40, 0.28) 100%);
    //   opacity: 0.28;

    font-size: 16px;
    color: #01b3e6;
    font-weight: 500;
  }
  .item:hover {
    color: #fff;
    background: linear-gradient(90deg, #2a3895 0%, rgba(4, 24, 40, 0.28) 100%);
  }
  .active {
    color: #fff;
    background: linear-gradient(90deg, #2a3895 0%, rgba(4, 24, 40, 0.28) 100%);
  }
}
.table-name {
  color: #abd1e7;
}
// ::v-deep {
//   .el-dialog {
//     // 取消阴影和背景色
//     background: rgba(0, 0, 0, 0);

//     -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0);

//     box-shadow: 0 1px 3px rgba(0, 0, 0, 0);
//   }
//   .el-input__inner {
//     height: 42px;
//     border: 1px solid #077fd4;
//     border-radius: 8px;
//     background: none;
//     color: #01b3e6;
//   }
//   .el-dialog__headerbtn {
//     top: 78px;
//     right: 100px;
//     z-index: 122;
//     font-size: 30px;
//     color: #fff;
//     font-size: bold;
//   }
//   .el-table,
//   .el-table__body {
//     background: transparent !important;
//     color: #fff;
//   }
//   .el-table th {
//     background-color: transparent !important;
//   }
//   .el-table tr {
//     background-color: transparent !important;
//   }
//   .el-table__body tr.hover-row > td {
//     background-color: #a5ccf2 !important;
//   }
//   .el-table tbody tr:hover > td {
//     background-color: #17468d !important //修改成自己想要的颜色即可
// ;
//   }
// }
</style>
